import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';

import CustomizeColor from './color-item'

const SelectLogoColor = ({
   colors,
   onSelect,
   activeColor,
   customColor,
   id,
   label,
   isMobile,
}) => {
   const [scrollLeft, setScrollLeft] = useState(0)
   const [hiddenButtons, setHiddenButtons] = useState(true)

   function handleClick(direction){
      const container = document.querySelector(`#select_color_${ id }`)
      sideScroll(container, direction, 80, 100, 250);
   }
   function sideScroll(element, direction, speed, distance, step){
      let scrollAmount = 0;
      let left = element.scrollLeft
      var slideTimer = setInterval(function(){
         if(direction === 'left'){
            left -= step;
            setScrollLeft(left)
         } else {
            left += step;
            setScrollLeft(left)
         }
         element.scrollTo(left, 0)
         scrollAmount += step;
         if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
         }
      }, speed);

   }
   const element = document.querySelector(`#select_color_${ id }`)
   let scrollEnd = 0
   if(element) {
      scrollEnd = element.scrollWidth - element.getBoundingClientRect().width
   }
   return (
      <div
         role='presentation'
         onFocus={ () => {
            if(isMobile) return
            setHiddenButtons(false)
         } }
         onMouseOver={ () => {
            if(isMobile) return
            setHiddenButtons(false)
         } }
         onMouseLeave={ () => {
            if(isMobile) return
            setHiddenButtons(true)
         } }
         className='w-full flex flex-col relative'>

         <div
            className='w-full flex flex-col'>
            {
               (!hiddenButtons && scrollLeft > 0) && (
                  <div
                     style={ {
                        top: '30px',

                     } }
                     className='shadow dark:shadow-dark absolute left-0 z-10 ml-3 w-9 h-9 scroll-button rounded-full bg-panel border border-divider'>
                     <Button
                        classNames='w-full h-full'
                        padding='none'
                        borderRadius='full'
                        backgroundColor='panel'
                        fontIconColor='major'
                        fontIconSize='large'
                        iconName='arrow-left'
                        onClick={ () => handleClick('left') }
                     />
                  </div>

               )
            }

            <span className='text-base font-medium leading-tight mb-2 select-none text-major'>{label}</span>
            <div
               id={ `select_color_${ id }` }
               className='flex items-center flex-1 overflow-x-auto  overflow-y-hidden max-w-full'
            >
               <CustomizeColor
                  color={ customColor || '#F8F9FA' }
                  isActive={ customColor === activeColor }
                  custom
                  saveCustomColor={ (color) => {
                     onSelect(color, true)
                  } }
               />
               {
                  colors.map((color, index) => {
                     return (
                        <div className='flex flex-col gap-2'>
                           <CustomizeColor
                              key={ index.toString() }
                              color={ color }
                              isActive={ color === activeColor }
                              onClick={ (color) => {
                                 onSelect(color, false)
                              } }
                           />
                           {
                              color === activeColor &&
                              <p className='text-xs text-secondary'>{customColor}</p>
                           }
                        </div>
                     )
                  })
               }
            </div>
            {
               (!hiddenButtons && ((scrollLeft !== scrollEnd && scrollLeft < scrollEnd) || scrollLeft === 0)) && (
                  <div
                     style={ {
                        top: '30px',
                     } }
                     className='shadow dark:shadow-dark absolute right-0 mr-3  w-9 h-9 scroll-button rounded-full  bg-panel border border-divider'>

                     <Button
                        classNames='w-full h-full'
                        padding='none'
                        borderRadius='full'
                        fontIconColor='major'
                        fontIconSize='large'
                        backgroundColor='panel'
                        iconName='arrow-right'
                        onClick={ () => handleClick('right') }
                     />
                  </div>
               )
            }
         </div>
      </div>
   )
}

SelectLogoColor.propTypes = {
   colors: PropTypes.array,
   onSelect: PropTypes.func,
   activeColor: PropTypes.string,
   customColor: PropTypes.string,
   id: PropTypes.string,
   label: PropTypes.string,
   isMobile: PropTypes.bool,
}

export default SelectLogoColor
